import React from "react";

import logoImg from "../img/header-logo.svg";
import logoSpectra from "../img/icon-spectra.svg";

import "../style/footer.css";

function Footer() {
    return (
        <footer className="footer-container">
            <div className="footer-wrapper">
                <img src={logoImg} alt="" className="logo-img" />
                <div className="menu-wrapper">
                    <a href="/">Início</a>
                    <a href="/#about">Quem somos</a>
                    <a href="http://wa.me/+552122000888">Suporte</a>
                </div>
                <div className="menu-wrapper">
                    <a href="/#fix">2KFIXO</a>
                    <a href="/#mobile">2KMÓVEL</a> 
                    <a href="/#dest">2KPLAY</a>
                </div>
                <div className="menu-wrapper">
                    <a href="/seja-parceiro">Seja Parceiro</a>
                    <a href="/faq">FAQ</a>
                    <a href="/termos-de-privacidade">Termos de privacidade</a>
                </div>
            </div>
            <b>2K20 SERVICO DE STREAMING E TV POR ASSINATURA LTDA - CNPJ: 52.631.616/0001-64</b>
            <span className="spectra">
                Desenvolvido por 
                <a href="https://spectra.tec.br" target="_blank">
                    <img src={logoSpectra}/>
                </a>
            </span>
        </footer>
    )
}

export default Footer;